import { render, staticRenderFns } from "./lostMerchant.vue?vue&type=template&id=5adcd123&scoped=true&"
import script from "./lostMerchant.vue?vue&type=script&lang=js&"
export * from "./lostMerchant.vue?vue&type=script&lang=js&"
import style0 from "./lostMerchant.vue?vue&type=style&index=0&id=5adcd123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adcd123",
  null
  
)

export default component.exports